'use strict';
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Mixins = require("./Mixins");
exports.baseFontSize = 20;
exports.base = __assign({ margin: '0', padding: '0', fontSize: exports.baseFontSize + "px", fontFamily: 'roboto' }, Mixins.boxSizing('border-box'), Mixins.userSelect('none'));
exports.buttonBase = {
    cursor: 'pointer',
    display: 'inline-block',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
    border: '1px solid transparent',
    paddingTop: 0.375 * exports.baseFontSize + "px",
    paddingBottom: 0.375 * exports.baseFontSize + "px",
    paddingLeft: 0.75 * exports.baseFontSize + "px",
    paddingRight: 0.75 * exports.baseFontSize + "px",
    fontSize: exports.baseFontSize + "px",
    lineHeight: '1.5',
    borderRadius: 0.25 * exports.baseFontSize + "px",
    transition: "color .15s ease-in-out, background-color .15s ease-in-out,\n    border-color .15s ease-in-out, box-shadow .15s ease-in-out",
    color: 'rgb(255, 255, 255)',
    backgroundColor: 'rgb(0, 123, 255)',
    borderColor: 'rgb(0, 123, 255)',
};
exports.buttonHoverBase = {
    color: 'rgb(255, 255, 255)',
    backgroundColor: 'rgb(0, 105, 217)',
    borderColor: 'rgb(0, 98, 204)',
    textDecoration: 'none',
};
exports.buttonActiveBase = {
    color: 'rgb(255, 255, 255)',
    backgroundColor: 'rgb(0, 98, 204)',
    borderColor: 'rgb(0, 92, 191)',
    backgroundImage: 'none',
};
exports.buttonFocusBase = {
    boxShadow: "0 0 0 " + 0.2 * exports.baseFontSize + "px rgba(0, 123, 255, 0.5)",
    outline: '0',
    textDecoration: 'none',
};
exports.bgImgBase = {
    backgroundSize: '80%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
};
exports.formElemBase = {
    fontSize: 0.75 * exports.baseFontSize + "px",
    padding: 0.1 * exports.baseFontSize + "px",
    marginLeft: 0.5 * exports.baseFontSize + "px",
};
exports.imageBase = {
    border: '0',
};
exports.headerBtnBase = {
    position: 'relative',
    float: 'left',
    fontSize: 0.75 * exports.baseFontSize + "px",
};
exports.headerImgBase = __assign({}, exports.imageBase, { height: '100%', width: 'auto', marginRight: 0.5 * exports.baseFontSize + "px" });
exports.headerDivBase = {
    position: 'relative',
    float: 'left',
    width: '15%',
    height: '100%',
    minWidth: '120px',
};
//# sourceMappingURL=General.js.map


//////////////////
// WEBPACK FOOTER
// ./src/js/styles/General.js
// module id = 11
// module chunks = 0